import { create } from "zustand";

export let useFileUploaderModal = create((set, get) => ({
  display: false,
  vendorId: undefined,
  vendorIndex: undefined,
  vendorName: undefined,
  purchaseOrderId: undefined,

  showFileUploaderModal: async (
    purchaseOrderId,
    vendorIndex,
    vendorId,
    vendorName
  ) => {
    set({ display: true, vendorId, vendorIndex, purchaseOrderId, vendorName });
  },

  closeModal: () => {
    set({ display: false });
  },
}));
